// Normalises API/error objects into a single Dutch-safe string so a FastAPI
// 422 (whose `detail` is an array of objects) can never be rendered directly
// into JSX (which throws "Objects are not valid as a React child").
export function getErrorMessage(err, fallback = "Er ging iets mis. Probeer het opnieuw.") {
  const detail = err?.response?.data?.detail;

  if (typeof detail === "string" && detail.trim()) return detail;

  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => (typeof d === "string" ? d : d?.msg))
      .filter(Boolean);
    if (msgs.length) return msgs.join(", ");
  }

  if (detail && typeof detail === "object" && detail.msg) return detail.msg;

  if (err?.response?.status === 429) {
    return "Te veel pogingen. Wacht even en probeer opnieuw.";
  }

  // No response at all = connection/timeout problem. Never surface a raw
  // technical string like "Network Error" to the user.
  if (isNetworkError(err)) {
    return "Geen verbinding. Probeer het zo nog eens.";
  }

  return fallback;
}

// True when the request never reached the server (offline, timeout, DNS, CORS
// preflight failure). Used to show a "try again" message rather than a scary one.
export function isNetworkError(err) {
  if (!err) return false;
  if (err.response) return false;
  if (err.code === "ECONNABORTED" || err.code === "ERR_NETWORK") return true;
  if (typeof err.message === "string" && /network|timeout/i.test(err.message)) return true;
  return err.request != null; // request made, no response received
}
